import $ from 'jquery'

$('.closed-client-space-modal').on('click', function () {
  $('#client-space-modal').modal('hide')
})
